import { HeartHandshake, ShieldCheck, Sparkles, Zap } from "lucide-react";
import { FadeUp, SectionHead } from "./Reveal";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "وضوح التعامل",
    text: "تفاصيل مباشرة وشفافة في كل خطوة، بلا مفاجآت ولا وعود فضفاضة.",
  },
  {
    icon: Zap,
    title: "سرعة الاستجابة",
    text: "رد سريع عبر واتساب والاتصال، لأن وقتك جزء من الصفقة.",
  },
  {
    icon: Sparkles,
    title: "الاهتمام بالتفاصيل",
    text: "نراجع التفاصيل الصغيرة قبل الكبيرة، لأنها ما يصنع تجربة مريحة.",
  },
  {
    icon: HeartHandshake,
    title: "خدمة العميل",
    text: "نستمع لاحتياجك أولًا، ثم نوصي بما يناسبه فعلًا.",
  },
];

export default function WhyShaydan() {
  return (
    <section id="why" data-testid="why-section" className="bg-cream py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHead eyebrow="WHY SHIYADN" eyebrowAr="لماذا شيادن" title="مبادئ مهنية، لا شعارات" testId="why-heading" />

        <div>
          {POINTS.map((p, i) => (
            <FadeUp key={p.title} delay={i * 0.08}>
              <div
                data-testid={`why-point-${i + 1}`}
                className="group grid items-center gap-4 border-t border-ink/10 py-8 transition-colors duration-500 last:border-b hover:bg-white/60 md:grid-cols-[auto_1fr_2fr] md:gap-12 md:py-10 md:px-4"
              >
                <span className="flex items-center gap-5">
                  <span className="font-display text-xl text-copper/70">٠{["١", "٢", "٣", "٤"][i]}</span>
                  <p.icon
                    className="h-8 w-8 text-petrol transition-colors duration-500 group-hover:text-copper"
                    strokeWidth={1.5}
                  />
                </span>
                <h3 className="font-head text-xl md:text-2xl font-bold text-navy">{p.title}</h3>
                <p className="text-sm md:text-base leading-relaxed text-ink/60">{p.text}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
